import { Grid, Stack } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import TopSection from "../../../Components/Common/Top/TopSection";
import BPHistoryTracker from "./BPHistoryTracker";
import { setActiveDataElement } from "../../../redux/userSlice";


const BPHistory = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveDataElement("Bottler Business Plan"));
  }, [dispatch]);

  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection
              title="Bottler Business Plan Upload History"
            />
            <div class="container">
              {/* top table */}
              <BPHistoryTracker />
             
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default BPHistory;
